import { Fragment } from 'react';
import classnames from 'classnames';
import { ClinicalSpecialistCard } from '@lp/features/RoutePlanner/components/CaseInformation/ClinicalSpecialistCard';
import { OcsDeviceCard } from '@lp/features/RoutePlanner/components/CaseInformation/OcsDeviceCard';
import { SurgeonCard } from '@lp/features/RoutePlanner/components/CaseInformation/SurgeonCard';
import { ResourceListType } from '@lp/features/RoutePlanner/hooks/useResourcesList';
import { CaseFacility, CaseResourceType } from '@/api/apis/case';

type LogisticsResourcesProps = {
  resources: ResourceListType[];
  donorHospital?: CaseFacility;
  disabled?: boolean;
};

export const LogisticsResourcesList = ({ resources, donorHospital, disabled }: LogisticsResourcesProps) => (
  <div className={classnames('flex gap-2 items-center pb-3', { 'overflow-auto px-3 scroll-sm': disabled })}>
    {resources.map((data, index) => (
      <Fragment key={data.item?.resourceId || index}>
        {data.type === CaseResourceType.ClinicalSpecialist && (
          <ClinicalSpecialistCard id={data.item?.resourceId} donorHospital={donorHospital} disabled={disabled} />
        )}
        {data.type === CaseResourceType.OCSConsole && (
          <OcsDeviceCard id={data.item?.resourceId} donorHospital={donorHospital} disabled={disabled} />
        )}
        {data.type === CaseResourceType.Surgeon && (
          <SurgeonCard id={data.item?.resourceId} donorHospital={donorHospital} disabled={disabled} />
        )}
      </Fragment>
    ))}
  </div>
);
